export const BRAND_ID = 'B61A4A08-1914-49CD-B86E-60D5D00575F9';

// Accent (003) still chats via CommunicationHub/Twilio; all other brands use the omnichannel 1-on-1 chat.
export const ACCENT_BRAND_ID = '4B0C292F-5688-4FAA-9C7B-4431B9F0BE54';

